import { useEffect, useState } from 'react';
import Collapsible from 'react-collapsible';
import { images } from '../../../Constants/ImageUrls';
import {
  applyGesture,
  handleWidgetAccToUser,
} from '../../../Utils/productPageUtils';
import { categoryNameCollapsed, categoryNameExpanded } from './common';
import { ResponsiveImage, SectionContainer, SectionTitle } from './styled';

export default function Banner(props) {
  const {
    bannerUrl,
    bannerAlt,
    title,
    productCategory,
    index,
    clickedHandler,
    itemData,
    Ido,
    WidgetContainImage,
    clinic,
    showNewLandingPageUI,
    showNewBannerWidgetView,
  } = props;
  const widgetIsOpened =
    index == 0 || Ido || !title || clinic || !itemData.default_collapsed;
  const [openWidget, setOpenWidget] = useState(widgetIsOpened);
  const [plusMinusDropDown, setPlusMinusDropDown] = useState(
    openWidget ? images.minusSvg : images.plusBlack,
  );

  const [gestureEffect, setGestureEffect] = useState('');
  const [widgetHandle, setWidgetHandle] = useState({
    widgetImage: '',
    widgetClass: '',
  });
  const handleWidgetState = (categoryNameState, widgetOpen, imageType) => {
    applyGesture(setGestureEffect);
    clickedHandler(categoryNameState, index, title);
    setOpenWidget(widgetOpen);
    setPlusMinusDropDown(imageType);
  };
  // useEffect(() => {
  //     setOpenWidget(showCollapsedView(index, WidgetContainImage));
  // }, [itemData]);

  useEffect(() => {
    handleWidgetAccToUser(plusMinusDropDown, setWidgetHandle);
  }, [plusMinusDropDown]);

  useEffect(() => {
    const state = widgetIsOpened;
    handleWidgetState(
      state ? categoryNameExpanded : categoryNameCollapsed,
      state,
      state ? images.minusSvg : images.plusBlack,
    );
  }, [itemData.default_collapsed]);

  return (
    <>
      <SectionContainer
        productcategory={productCategory}
        showNewLandingPageUI={showNewLandingPageUI}
        data-policy-widget={!!itemData?.is_policy}
        showNewBannerWidgetView={showNewBannerWidgetView}
      >
        <Collapsible
          // trigger={
          //     title || Ido ? (
          //         <SectionTitle
          //             className={` ${gestureEffect} aplusTitleSize`}
          //         >
          //             {title}
          //             <img
          //                 loading="lazy"
          //                 src={widgetHandle.widgetImage}
          //                 className={widgetHandle.widgetClass}
          //                 alt="arrow"
          //             />
          //         </SectionTitle>
          //     ) : null
          // }
          key={index}
          onOpening={() => {
            handleWidgetState(categoryNameExpanded, true, images.minusSvg);
          }}
          onClosing={() => {
            handleWidgetState(categoryNameCollapsed, false, images.plusBlack);
          }}
          transitionTime={200}
          open={openWidget}
          triggerOpenedClassName="triggerClassAplus"
        >
          <a id="Description" className="anchor" rel="nofollow"></a>
          <ResponsiveImage src={bannerUrl} alt={bannerAlt} loading="lazy" />
        </Collapsible>
      </SectionContainer>
    </>
  );
}
